import { render, staticRenderFns } from "./FrameInvoice.vue?vue&type=template&id=c009c76c&scoped=true"
import script from "./FrameInvoice.vue?vue&type=script&lang=js"
export * from "./FrameInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c009c76c",
  null
  
)

export default component.exports